module.exports = __webpack_public_path__ + "img/right.09caf9aa.svg";